var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm error-form",
      attrs: { model: _vm.formData, "label-width": "0", size: "small" },
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.formData.arr, border: "" } },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t("basicData.ExpenseType"), width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: { prop: "arr." + scope.$index + ".feeTypeCode" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("basicData.PleaseSelect"),
                            },
                            model: {
                              value: scope.row.feeTypeCode,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "feeTypeCode", $$v)
                              },
                              expression: "scope.row.feeTypeCode",
                            },
                          },
                          _vm._l(_vm.feeTypeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.displayName + "(" + item.code + ")",
                                value: item.code,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("receivablePayable.specialRules"),
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type === 1
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "arr." + scope.$index + ".overWeight",
                                  rules: {
                                    required: scope.row.feeTypeCode,
                                    suffix: 3,
                                    negative: "",
                                    validator: _vm.weightType,
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tas" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("GlobalSetObj.weight")) +
                                          ">"
                                      ),
                                    ]),
                                    _c("el-input", {
                                      model: {
                                        value: scope.row.overWeight,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "overWeight", $$v)
                                        },
                                        expression: "scope.row.overWeight",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "arr." + scope.$index + ".overSize",
                                  rules: {
                                    required: scope.row.feeTypeCode,
                                    suffix: 3,
                                    negative: "",
                                    validator: _vm.weightType,
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tas" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "receivablePayable.lengthWidthHeightCm"
                                          )
                                        ) + ">"
                                      ),
                                    ]),
                                    _c("el-input", {
                                      model: {
                                        value: scope.row.overSize,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "overSize", $$v)
                                        },
                                        expression: "scope.row.overSize",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("basicData.Price"), "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type === 1
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "arr." +
                                    scope.$index +
                                    ".overWeightExtraPrice",
                                  rules: {
                                    required: scope.row.feeTypeCode,
                                    suffix: 3,
                                    negative: "",
                                    validator: _vm.weightType,
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.overWeightExtraPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "overWeightExtraPrice",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scope.row.overWeightExtraPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "arr." +
                                    scope.$index +
                                    ".overSizeExtraPrice",
                                  rules: {
                                    required: scope.row.feeTypeCode,
                                    suffix: 3,
                                    negative: "",
                                    validator: _vm.weightType,
                                    trigger: ["blur", "change"],
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.overSizeExtraPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "overSizeExtraPrice",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.overSizeExtraPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }